import { render, staticRenderFns } from "./CustomQrCode.vue?vue&type=template&id=9fd4ffba"
import script from "./CustomQrCode.vue?vue&type=script&lang=js"
export * from "./CustomQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports